import { ESIGN_AUTOMATION_CODES } from "./automationCodes";

export const MODEL_FILES_BY_AUTOMATION_CODE = {
  [ESIGN_AUTOMATION_CODES.fichaAtendimento]: [
    {
      href: "/4uESign/modelos/ficha-paciente-com-variaveis.docx",
      downloadName: "ficha-paciente(com_variaveis).docx",
    },
  ],
  [ESIGN_AUTOMATION_CODES.guiaSP]: [
    {
      href: "/4uESign/modelos/modelo-guia-sp-sadt-v3-oficial.docx",
      downloadName: "Modelo_Guia_SP-SADT_V3_Oficial.docx",
    },
  ],
} as const;

export const getModelFilesForAutomationCode = (
  automationCode?: string | number | null,
) => {
  if (automationCode === null || automationCode === undefined) return [];

  return (
    MODEL_FILES_BY_AUTOMATION_CODE[
      automationCode.toString() as keyof typeof MODEL_FILES_BY_AUTOMATION_CODE
    ] ?? []
  );
};
